export const EDIT_ROLODEX_CONTACT_POPUP_TITLE_TEXT = {
    id: 'oe.rolodex.contact.editPopupTitle',
    defaultMessage: 'Edit Contact',
    description: 'Label text'
};

export const PREFERRED_NAME_TEXT = {
    id: 'oe.rolodex.contact.preferredName',
    defaultMessage: 'Preferred Name',
    description: 'Label text'
};

export const NAME_PREFIX_TEXT = {
    id: 'oe.rolodex.contact.namePrefix',
    defaultMessage: 'Prefix',
    description: 'Label text'
};

export const NAME_SUFFIX_TEXT = {
    id: 'oe.rolodex.contact.nameSuffix',
    defaultMessage: 'Suffix',
    description: 'Label text'
};

export const MIDDLE_NAME_TEXT = {
    id: 'oe.rolodex.contact.middleName',
    defaultMessage: 'Middle Name',
    description: 'Label text'
};

export const NAME_NOTES_TEXT = {
    id: 'oe.rolodex.contact.nameNotes',
    defaultMessage: 'Name Notes',
    description: 'Label text'
};

export const NAME_PHONETIC_TEXT = {
    id: 'oe.rolodex.contact.namePhonetic',
    defaultMessage: 'Name Phonetic',
    description: 'Label text'
};

export const NAME_PRONUNCIATION_TEXT = {
    id: 'oe.rolodex.contact.namePronunciation',
    defaultMessage: 'Name Pronunciation',
    description: 'Label text'
};

export const PHONE_DIRECT_TEXT = {
    id: 'oe.rolodex.contact.phoneDirect',
    defaultMessage: 'Direct Phone',
    description: 'Label text'
};

export const PHONE_MOBILE_TEXT = {
    id: 'oe.rolodex.contact.phoneMobile',
    defaultMessage: 'Mobile Phone',
    description: 'Label text'
};

export const LINKEDIN_URL_TEXT = {
    id: 'oe.rolodex.contact.linkedinUrl',
    defaultMessage: 'LinkedIn Url',
    description: 'Label text'
};

export const ACTIVE_STATUS_TEXT = {
    id: 'oe.rolodex.contact.activeStatus',
    defaultMessage: 'Active Status',
    description: 'Label text'
};

export const VIP_FLAG_TEXT = {
    id: 'oe.rolodex.contact.vip',
    defaultMessage: 'VIP',
    description: 'Label text'
};

export const CONTACT_UPDATE_SUCCESS_TEXT = {
    id: 'oe.rolodex.contact.updateSuccessText',
    defaultMessage: 'Contact details updated.',
    description: 'Label text'
};

export const VIP_LABEL_TEXT = {
    message: 'VIP Contact',
    id: 'oe.rolodex.contact.vipStatus',
    description: 'Label text',
};

export const RECORD_AUDIO_TEXT = {
    id: 'oe.rolodex.contact.recordAudio',
    defaultMessage: 'Record Audio',
    description: 'Label text'
};

export const UPLOAD_AUDIO_FILE_TEXT = {
    id: 'oe.rolodex.contact.uploadAudioFile',
    defaultMessage: 'Upload Audio File',
    description: 'Label text'
};

export const RECORD_NAME_PRONUNCIATION_AUDIO_TEXT = {
    id: 'oe.rolodex.contact.recordNamePronunciationAudio',
    defaultMessage: 'Record Name Pronunciation Audio',
    description: 'Label text'
};

export const UPLOAD_NAME_PRONUNCIATION_AUDIO_FILE_TEXT = {
    id: 'oe.rolodex.contact.uploadNamePronunciationAudioFile',
    defaultMessage: 'Upload Name Pronunciation Audio File',
    description: 'Label text'
};

export const ADDITIONAL_NAME_DETAILS_TEXT = {
    id: 'oe.rolodex.contact.additionalNameDetails',
    defaultMessage: 'Additional Name Details',
    description: 'Label text'
};

export const AUDIO_FOR_THIS_CONTACT_TEXT = {
    id: 'oe.rolodex.contact.confirm.theNamePronunciationAudioForThisContact',
    defaultMessage: 'the name pronunciation audio for this contact',
    description: 'Label text'
};

export const AUDIO_ADDED_TO_CONTACT_TEXT = {
    id: 'oe.rolodex.contact.confirm.audioAddedToContact',
    defaultMessage: 'Audio recording successfully added.',
    description: 'Label text'
};

export const AUDIO_REMOVED_FROM_THE_CONTACT_TEXT = {
    id: 'oe.rolodex.contact.confirm.audioRemovedFromTheContact',
    defaultMessage: 'Audio recording successfully removed.',
    description: 'Label text'
};

export const REMOVE_AUDIO_TEXT = {
    id: 'oe.rolodex.contact.removeAudio',
    defaultMessage: 'Remove Audio',
    description: 'Label text'
};
